import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { requests } from "../../../common/RestAPI";
import { SESSIONSTORAGE } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import { ALERTS, POPUP_TYPE } from "../../../value/type";

import ContentsProps from "../../../interfaceTypes/ContentsProps";

import { actionMenus, tableHeaders, podVolumeAddModalContent, PodVolumeMgmtData } from "./PodVolumeData";
import { PopupModalItemType } from "../../base/modal/PopupModal";
import PodVolumeMgmt from "./PodVolumeMgmt";
import { generateQueryParam, getTimestampToDate } from "../../../common/util";

export default function PodVolumeMgmtContainer(props:ContentsProps) {
    const { t } = useTranslation();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const fetchIdRef = useRef(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [selectItems, setSelectItems] = useState([]);
    const [tableData, setTableData] = useState<PodVolumeMgmtData[]>([PodVolumeMgmtData]);
    const [refreshYn, setRefreshYn] = useState(false);

    const [executeDeletePodVolumeYn, setExecuteDeletePodVolumeYn] = useState(false);

    const [actionResultTitle, setActionResultTitle] = useState("");
    const [actionResultMessage, setActionResultMessage] = useState("");
    const [actionResults, setActionResults] = useState<PopupModalItemType[]>([]);
    const [actionResultCount, setActionResultCount] = useState(0);

    const headers = useMemo(() => tableHeaders, []);
    const navigate = useNavigate();


    useEffect(() => {
        AlertFunction('');
    }, []);

    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }

    useEffect(() => {
        if(actionResults.length === 0) {
            return ;
        }
        if(actionResultMessage && actionResultTitle) {
            const items = actionResults.map((item, index) => {
                return { target: item.target, successYn: item.successYn, reason: item.reason}
            });
            const completeYn = items.length === selectItems.length ? true : false;
            props.showPopupModalCb({
                openYn: true,
                type: POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP,
                title: actionResultTitle,
                message: actionResultMessage,
                items: items,
                completeTargetText: t("PVC_NAME_TEXT"),
                code: "COMPLETE",
                cancelButtonYn: false,
                confirmButtonCb: confirmAction,
                completeYn: completeYn
            });

            if(completeYn) {
                props.setLoading(false);
            }
        }
        if(actionResults.length > 0) {
            setActionResultCount(actionResultCount - 1);
        }
    }, [actionResults, actionResultTitle, actionResultMessage]);


    useEffect(() => {
        if(actionResultCount === selectItems.length) {
            props.setLoading(true);
        }
        if(actionResultCount > 0) {
            if(executeDeletePodVolumeYn) {
                setActionResultTitle(t("PVC_DELETE_COMPLETE_TEXT"));
                setActionResultMessage(t("MESSAGE_PVC_DELETE_COMPLETE_MESSAGE"));
                executeDeletePodVolume(selectItems[selectItems.length - actionResultCount]);
            }
        }
    }, [actionResultCount, executeDeletePodVolumeYn]);


    function executeResult(target, successYn, reason:string="") {
        const results = actionResults.concat([{target: target, successYn: successYn, reason:reason }]);
        setActionResults(results);
    }

    function executeDeletePodVolume(item) {
        requests.delete(PLATFORM_URL.POD_PVC + "/" + item.persistent_volume_claim_id)
        .then((response) => {
            executeResult(item.persistent_volume_claim_name, true);
        })
        .catch((error) => {
            let reason = '';
            if(error.status === 406) {
                reason = t("MESSAGE_PVC_DELETE_CANNOT_IN_LIST_MESSAGE")
            }
            executeResult(item.persistent_volume_claim_name, false, reason);
        })
    }

    function checkSelectItems(code) {
        let actionYn = true;
        if(code === "POD_VOLUME_DELETE") {
            selectItems.map((item:any, index) => {
                // TODO
                if(item.attachYn) {
                    actionYn = false;
                }
            });
        }
        return actionYn;
    }

    function addPodResult(data) {
        if(data.successYn) {
            AlertFunction(t("MESSAGE_PVC_ADD_SUCCESS_MESSAGE"));
            setRefreshYn(true);
        }
    }

    function confirmAction(code) {
        if(code === "POD_VOLUME_DELETE") {
            setActionResultCount(selectItems.length);
            setExecuteDeletePodVolumeYn(true);
        } else if(code !== "COMPLETE") {
            setActionResultCount(selectItems.length);
        } else {
            setActionResultCount(0);
            setActionResults([]);
            setActionResultMessage("");
            setActionResultTitle("");
            setExecuteDeletePodVolumeYn(false);
            setRefreshYn(true);
            AlertFunction('');
        }
    }

    function clickActionMenu(code) {
        if(code === "POD_VOLUME_CREATE") {
            props.showSlideModalCb({...podVolumeAddModalContent, openYn: true, resultCb: addPodResult});
        } else if(code === "POD_VOLUME_DELETE") {
            
            props.showPopupModalCb({openYn: true,
                type: POPUP_TYPE.LIST_MESSAGE_WITH_TITLE_POPUP,
                title: t("MESSAGE_PVC_DELETE_REQUEST_TITLE_MESSAGE"),
                message: t("MESSAGE_PVC_DELETE_REQUEST_MESSAGE"),
                items: selectItems.map((item: any, index) => {
                        return { target: item.persistent_volume_claim_name }
                }),
                code: "POD_VOLUME_DELETE",
                cancelButtonYn: true,
                confirmButtonCb: confirmAction,

            });
        } else if (code === 'POD_VOLUME_SYNC') {
            requests.post(PLATFORM_URL.POD_PVC + PLATFORM_URL.SYNC, {})
            .then((response) => {
                if (response.status === 200) {
                    AlertFunction(t("SYNC_COMPLETED_TEXT"));
                }
            })
        }
    }


    function selectRow(items) {
        // !!선택 테이블인 경우 액션 메뉴 상태 변경 커스텀
        setSelectItems(items);

        if(items.length > 0) {
            setActionMenuStatus(2, true);
        } else {
            setActionMenuStatus(2, false);
        }
    }


    function executeLoadPodVolumeList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading) {
        if(showLoading) {
            setCurrentPage(pageIndex);
            props.setLoading(true);
        }

        requests.get(PLATFORM_URL.POD_PVC, generateQueryParam(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search))
        .then((response) => {
            if (response.status === 200 && response.data && pageIndex === response.data.page-1) {
                setTableData(response.data.items);
                setPageCount(response.data.pages);
                setTotalItemCount(response.data.total);
            }
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
        .catch((error) => {
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
    }


    function setActionMenuStatus(id, activeYn) {
        actionMenus[id - 1].activeYn = activeYn;
    }


    const fetchData = useCallback(({ pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading }) => {
        const fetchId = ++fetchIdRef.current
        if(fetchId === fetchIdRef.current) {
            executeLoadPodVolumeList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading);
        }
    }, []);


    return (
        <PodVolumeMgmt
            clickActionMenu={clickActionMenu}
            selectRow={selectRow}
            fetchData={fetchData}
            currentPage={currentPage}
            pageCount={pageCount}
            headers={headers}
            tableData={tableData}
            totalItemCount={totalItemCount}
            refreshYn={refreshYn}
            infoText={infoText}
            infoError={infoError}
        />
    )
}